/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";

const MyTableCell = styled(TableCell)`
  font-size: 12px;
`;

export default function HrDebug({ bands, cid }) {
  return (
    <Box
      position="absolute"
      backgroundColor="white"
      m={2}
      bottom={60}
      fontSize={12}
      zIndex={999}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <MyTableCell>cid</MyTableCell>
              <MyTableCell>밴드번호</MyTableCell>
              <MyTableCell>시리얼</MyTableCell>
              <MyTableCell>최대심박</MyTableCell>
              <MyTableCell>심박수</MyTableCell>
              <MyTableCell>최고심박수</MyTableCell>
              <MyTableCell>포인트전송</MyTableCell>
              <MyTableCell>심박포인트</MyTableCell>
              <MyTableCell>mcd</MyTableCell>
              <MyTableCell>z1</MyTableCell>
              <MyTableCell>z2</MyTableCell>
              <MyTableCell>z3</MyTableCell>
              <MyTableCell>z4</MyTableCell>
              <MyTableCell>칼로리</MyTableCell>
              <MyTableCell>칼로리샷</MyTableCell>
              <MyTableCell>칼로리포인트</MyTableCell>
              <MyTableCell>프리퀀시(신호주기)</MyTableCell>
              <MyTableCell>zone</MyTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bands.map((item, index) => {
              return (
                <TableRow key={index}>
                  <MyTableCell>{cid}</MyTableCell>
                  <MyTableCell>{item.band_no}</MyTableCell>
                  <MyTableCell>{item.device_id}</MyTableCell>
                  <MyTableCell>{item.heart_max_rate}%</MyTableCell>
                  <MyTableCell>{item.heart_beat}</MyTableCell>
                  <MyTableCell>{item.heart_beat_max}</MyTableCell>
                  <MyTableCell>{item.heart_point}</MyTableCell>
                  <MyTableCell>{item.zone_point}</MyTableCell>
                  <MyTableCell>{item.mcd}</MyTableCell>
                  <MyTableCell>{item.zone1}</MyTableCell>
                  <MyTableCell>{item.zone2}</MyTableCell>
                  <MyTableCell>{item.zone3}</MyTableCell>
                  <MyTableCell>{item.zone4}</MyTableCell>
                  <MyTableCell>{parseInt(item.kcal)} kcal</MyTableCell>
                  <MyTableCell>{item.kcal_shot} kcal</MyTableCell>
                  <MyTableCell>{item.kpoint} pt</MyTableCell>
                  <MyTableCell>{parseInt(item.frequency)}</MyTableCell>
                  <MyTableCell>{parseInt(item.heart_zone)}</MyTableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
